import React, { FC, useContext } from 'react';
import {
  DataLayerContext,
  DataLayerContextType,
} from '../../providers/data-layer/data-layer.provider';
import { AccountBenefitsType } from '../../../models/account-benefits-type';
import GtmEventNameEnum from '../../../models/gtm-event-name-enum';
import ButtonPrimary from '../../atoms/button-primary/button-primary';
import RichText from '../../molecules/rich-text/rich-text';

const AccountBenefits: FC<AccountBenefitsType> = ({
  description,
  heading,
  link,
}: AccountBenefitsType) => {
  const { pushToDataLayer } =
    useContext<DataLayerContextType>(DataLayerContext);

  return (
    <div className="py-component-spacing-mobile lg:py-component-spacing">
      <div className="mx-auto lg:ml-20 w-full md:w-7/12 lg:w-9/12 xl:w-7/12">
        <h3 className="page-heading-three mb-4">{heading}</h3>

        {description && <RichText className="mb-8">{description}</RichText>}

        {link && (
          <ButtonPrimary
            {...link}
            onClick={() => pushToDataLayer(GtmEventNameEnum.DetailsBenefits)}
          />
        )}
      </div>
    </div>
  );
};

export default AccountBenefits;
